export default __webpack_public_path__ + "abeb05a0be1a46dc700c599e1b5d561f.png";